// 后台管理路由页面配置
import Backstage from "../../views/Backstage/main/index.vue"; // 后台管理页面
export const BackstageRouter = [
  {
    path: "/wenxiang_Backstage",
    name: "Backstage",
    component: Backstage,
    redirect: "/wenxiang_Backstage/Live",
    children: [
      {
        // 直播管理
        path: "/wenxiang_Backstage/Live",
        name: "Live",
        component: () => import("../../views/Backstage/Live/index.vue"),
        meta: {
          affiliation_Head: "Backstage", // 归属级 (头部的) **默认Backstage**
          affiliation_Left: "Live", // 归属级 (左侧的)
        },
      },
      {
        // 直播管理-新增-编辑
        path: "/wenxiang_Backstage/liveAddset",
        name: "liveAddset",
        component: () =>
          import("../../views/Backstage/Live/liveAddset/liveAddset.vue"),
        meta: {
          affiliation_Head: "Backstage", // 归属级 (头部的) **默认Backstage**
          affiliation_Left: "Live", // 归属级 (左侧的)
        },
      },
      {
        // 直播数据
        path: "/wenxiang_Backstage/LiveData",
        name: "LiveData",
        component: () =>
          import("../../views/Backstage/Live/liveData/Livedata.vue"),
        meta: {
          affiliation_Head: "Backstage", // 归属级 (头部的) **默认Backstage**
          affiliation_Left: "Live", // 归属级 (左侧的)
        },
      },
      {
        // 录播资源管理
        path: "/wenxiang_Backstage/Recording_resources",
        name: "Recording_resources",
        component: () =>
          import("../../views/Backstage/RecordingResources/index.vue"),
        meta: {
          affiliation_Head: "Backstage", // 归属级 (头部的) **默认Backstage**
          affiliation_Left: "Recording_resources", // 归属级 (左侧的)
        },
      },
      {
        // 课程管理
        path: "/wenxiang_Backstage/Course",
        name: "Course",
        component: () => import("../../views/Backstage/Course/index.vue"),
        meta: {
          affiliation_Head: "Backstage", // 归属级 (头部的) **默认Backstage**
          affiliation_Left: "Course", // 归属级 (左侧的)
        },
      },
      {
        // 课程管理-新增-编辑
        path: "/wenxiang_Backstage/CourseAddset",
        name: "CourseAddset",
        component: () =>
          import("../../views/Backstage/Course/CourseAddset/CourseAddset.vue"),
        meta: {
          affiliation_Head: "Backstage", // 归属级 (头部的) **默认Backstage**
          affiliation_Left: "Course", // 归属级 (左侧的)
        },
      },
      {
        // 课程管理(课程信息/课程章节)
        path: "/wenxiang_Backstage/CourseNew",
        name: "CourseNew",
        component: () => import("../../views/Backstage/CourseNew/index.vue"),
        meta: {
          affiliation_Head: "Backstage", // 归属级 (头部的) **默认Backstage**
          affiliation_Left: "CourseNew", // 归属级 (左侧的)
        },
      },
      {
        // 课程管理-新建课程
        path: "/wenxiang_Backstage/CourseNewAddCourse",
        name: "CourseNewAddCourse",
        component: () => import("../../views/Backstage/CourseNew/AddCourse.vue"),
        meta: {
          affiliation_Head: "Backstage", // 归属级 (头部的) **默认Backstage**
          affiliation_Left: "CourseNew", // 归属级 (左侧的)
        },
      },
      {
        // 课程管理-测验管理
        path: "/wenxiang_Backstage/CourseNewTest",
        name: "CourseNewTest",
        component: () => import("../../views/Backstage/CourseNew/Test.vue"),
        meta: {
          affiliation_Head: "Backstage", // 归属级 (头部的) **默认Backstage**
          affiliation_Left: "CourseNew", // 归属级 (左侧的)
        },
      },
      {
        // 课程管理-测验管理-详情
        path: "/wenxiang_Backstage/CourseNewDetail",
        name: "CourseNewDetail",
        component: () => import("../../views/Backstage/CourseNew/Detail.vue"),
        meta: {
          affiliation_Head: "Backstage", // 归属级 (头部的) **默认Backstage**
          affiliation_Left: "CourseNew", // 归属级 (左侧的)
        },
      },
      {
        // 课程管理-课程信息/课程章节
        path: "/wenxiang_Backstage/CourseInfoChapter",
        name: "CourseInfoChapter",
        component: () => import("../../views/Backstage/CourseInfoChapter/index.vue"),
        meta: {
          affiliation_Head: "Backstage", // 归属级 (头部的) **默认Backstage**
          affiliation_Left: "CourseNew", // 归属级 (左侧的)
        },
      },
      {
        // 课程管理-课程信息/知识点问题编辑
        path: "/wenxiang_Backstage/knowledegePointQuestion",
        name: "knowledegePointQuestion",
        component: () => import("../../views/Backstage/CourseInfoChapter/knowledeg-point-question.vue"),
        meta: {
          affiliation_Head: "Backstage", // 归属级 (头部的) **默认Backstage**
          affiliation_Left: "CourseNew", // 归属级 (左侧的)
        },
      },
      {
        // 课表管理
        path: "/wenxiang_Backstage/ClassSchedule",
        name: "ClassSchedule",
        component: () =>
          import("../../views/Backstage/ClassSchedule/index.vue"),
        meta: {
          affiliation_Head: "Backstage", // 归属级 (头部的) **默认Backstage**
          affiliation_Left: "ClassSchedule", // 归属级 (左侧的)
        },
      },
      {
        // 系列课
        path: "/wenxiang_Backstage/SeriesOfCourses",
        name: "SeriesOfCourses",
        component: () =>
          import("../../views/Backstage/SeriesOfCourses/index.vue"),
        meta: {
          affiliation_Head: "Backstage", // 归属级 (头部的) **默认Backstage**
          affiliation_Left: "SeriesOfCourses", // 归属级 (左侧的)
        },
      },
      {
        // 系列课-创建-编辑
        path: "/wenxiang_Backstage/SeriesOfCoursesAddSet",
        name: "SeriesOfCoursesAddSet",
        component: () =>
          import("../../views/Backstage/SeriesOfCourses/SeriesOfCoursesAddSet"),
        meta: {
          affiliation_Head: "Backstage", // 归属级 (头部的) **默认Backstage**
          affiliation_Left: "SeriesOfCourses", // 归属级 (左侧的)
        },
      },
      {
        // 系列课-list
        path: "/wenxiang_Backstage/SeriesOfCoursesLi",
        name: "SeriesOfCoursesLi",
        component: () =>
          import("../../views/Backstage/SeriesOfCourses/SeriesOfCoursesLi"),
        meta: {
          affiliation_Head: "Backstage", // 归属级 (头部的) **默认Backstage**
          affiliation_Left: "SeriesOfCourses", // 归属级 (左侧的)
        },
      },
      {
        // 系列课-list -创建-编辑
        path: "/wenxiang_Backstage/SeriesOfCoursesLiSet",
        name: "SeriesOfCoursesLiSet",
        component: () =>
          import("../../views/Backstage/SeriesOfCourses/SeriesOfCoursesLiSet"),
        meta: {
          affiliation_Head: "Backstage", // 归属级 (头部的) **默认Backstage**
          affiliation_Left: "SeriesOfCourses", // 归属级 (左侧的)
        },
      },
      {
        // 结对组管理
        path: "/wenxiang_Backstage/pairingCourse",
        name: "pairingCourse",
        component: () =>
          import("../../views/Backstage/pairingCourse/index.vue"),
        meta: {
          affiliation_Head: "Backstage", // 归属级 (头部的) **默认Backstage**
          affiliation_Left: "pairingCourse", // 归属级 (左侧的)
        },
      },
      {
        // 结对组管理-结对课程/结对教研
        path: "/wenxiang_Backstage/schoolInfo",
        name: "SchoolInfo",
        component: () =>
          import("../../views/Backstage/pairingCourse/SchoolInfo.vue"),
        meta: {
          affiliation_Head: "Backstage", // 归属级 (头部的) **默认Backstage**
          affiliation_Left: "SchoolInfo", // 归属级 (左侧的)
        },
      },
      {
        // 结对组管理-结对课程/结对教研-小组管理
        path: "/wenxiang_Backstage/GroupTable",
        name: "GroupTable",
        component: () =>
          import("../../views/Backstage/pairingCourse/GroupTable/index.vue"),
        meta: {
          affiliation_Head: "Backstage", // 归属级 (头部的) **默认Backstage**
          affiliation_Left: "SchoolInfo", // 归属级 (左侧的)
        },
      },
      {
        // 结对组管理-结对课程/结对教研-新建小组
        path: "/wenxiang_Backstage/AddGroupUser",
        name: "AddGroupUser",
        component: () =>
          import("../../views/Backstage/pairingCourse/GroupTable/AddGroup.vue"),
        meta: {
          affiliation_Head: "Backstage", // 归属级 (头部的) **默认Backstage**
          affiliation_Left: "SchoolInfo", // 归属级 (左侧的)
        },
      },
      {
        // 结对组管理-结对课程/结对教研-草稿箱
        path: "/wenxiang_Backstage/Drafts",
        name: "Drafts",
        component: () =>
          import("../../views/Backstage/pairingCourse/Drafts/index.vue"),
        meta: {
          affiliation_Head: "Backstage", // 归属级 (头部的) **默认Backstage**
          affiliation_Left: "SchoolInfo", // 归属级 (左侧的)
        },
      },
      {
        // 结对组管理-结对课程/结对教研-新建专递课程
        path: "/wenxiang_Backstage/AddCourse",
        name: "AddCourse",
        component: () =>
          import("../../views/Backstage/pairingCourse/AddCourse/index.vue"),
        meta: {
          affiliation_Head: "Backstage", // 归属级 (头部的) **默认Backstage**
          affiliation_Left: "SchoolInfo", // 归属级 (左侧的)
        },
      },
      {
        // 结对组管理-结对课程/结对教研-新建专递教研
        path: "/wenxiang_Backstage/AddTeaching",
        name: "AddTeaching",
        component: () =>
          import("../../views/Backstage/pairingCourse/AddTeaching/index.vue"),
        meta: {
          affiliation_Head: "Backstage", // 归属级 (头部的) **默认Backstage**
          affiliation_Left: "SchoolInfo", // 归属级 (左侧的)
        },
      },
      {
        // 远程互动
        path: "/wenxiang_Backstage/RemoteInteraction",
        name: "RemoteInteraction",
        component: () =>
          import("../../views/Backstage/RemoteInteraction/index.vue"),
        meta: {
          affiliation_Head: "Backstage", // 归属级 (头部的) **默认Backstage**
          affiliation_Left: "RemoteInteraction", // 归属级 (左侧的)
        },
      },{
        // 创建互动课程
        path: "/wenxiang_Backstage/createInteraction",
        name: "createInteraction",
        component: () =>
          import("../../views/Backstage/RemoteInteraction/createInteraction/index.vue"),
        meta: {
          affiliation_Head: "Backstage", // 归属级 (头部的) **默认Backstage**
          affiliation_Left: "RemoteInteraction", // 归属级 (左侧的)
        },
      },
      {
        // 教研组
        path: "/wenxiang_Backstage/TeachingAndResearch",
        name: "TeachingAndResearch",
        component: () =>
          import("../../views/Backstage/TeachingAndResearch/index.vue"),
        meta: {
          affiliation_Head: "Backstage", // 归属级 (头部的) **默认Backstage**
          affiliation_Left: "TeachingAndResearch", // 归属级 (左侧的)
        },
      },
      {
        // 教研组-新增
        path: "/wenxiang_Backstage/AddGroup",
        name: "AddGroup",
        component: () =>
          import(
            "../../views/Backstage/TeachingAndResearch/AddGroup/index.vue"
          ),
        meta: {
          affiliation_Head: "Backstage", // 归属级 (头部的) **默认Backstage**
          affiliation_Left: "TeachingAndResearch", // 归属级 (左侧的)
        },
      },
      {
        // 教研组-详情
        path: "/wenxiang_Backstage/GroupDetail",
        name: "GroupDetail",
        component: () =>
          import("../../views/Backstage/TeachingAndResearch/GroupDetail.vue"),
        meta: {
          affiliation_Head: "Backstage", // 归属级 (头部的) **默认Backstage**
          affiliation_Left: "TeachingAndResearch", // 归属级 (左侧的)
        },
      },
      {
        // 教研活动管理
        path: "/wenxiang_Backstage/CourseEvaluationSchedule",
        name: "CourseEvaluationSchedule",
        component: () =>
          import("../../views/Backstage/CourseEvaluationSchedule/index.vue"),
        meta: {
          affiliation_Head: "Backstage", // 归属级 (头部的) **默认Backstage**
          affiliation_Left: "CourseEvaluationSchedule", // 归属级 (左侧的)
        },
      },
      {
        // 新建教研
        path: "/wenxiang_Backstage/CourseAddResearch",
        name: "CourseAddResearch",
        component: () =>
          import("../../views/Backstage/CourseEvaluationSchedule/AddResearch/index.vue"),
        meta: {
          affiliation_Head: "Backstage", // 归属级 (头部的) **默认Backstage**
          affiliation_Left: "CourseEvaluationSchedule", // 归属级 (左侧的)
        },
      },
      {
        // 创建互动课程
        path: "/wenxiang_Backstage/CourseAddInteractiveCourse",
        name: "CourseAddInteractiveCourse",
        component: () =>
          import("../../views/Backstage/CourseEvaluationSchedule/InteractiveCourse.vue"),
        meta: {
          affiliation_Head: "Backstage", // 归属级 (头部的) **默认Backstage**
          affiliation_Left: "CourseEvaluationSchedule", // 归属级 (左侧的)
        },
      },
      {
        // 教研活动管理-草稿箱
        path: "/wenxiang_Backstage/CourseDraftList",
        name: "CourseDraftList",
        component: () =>
          import("../../views/Backstage/CourseEvaluationSchedule/DraftList.vue"),
        meta: {
          affiliation_Head: "Backstage", // 归属级 (头部的) **默认Backstage**
          affiliation_Left: "CourseEvaluationSchedule", // 归属级 (左侧的)
        },
      },
      {
        // 评课表管理
        path: "/wenxiang_Backstage/CourseClassSchedule",
        name: "CourseClassSchedule",
        component: () =>
          import("../../views/Backstage/CourseEvaluationSchedule/ClassSchedule/index.vue"),
        meta: {
          affiliation_Head: "Backstage", // 归属级 (头部的) **默认Backstage**
          affiliation_Left: "CourseEvaluationSchedule", // 归属级 (左侧的)
        },
      },
      {
        // 评课表管理-新建课表
        path: "/wenxiang_Backstage/CourseAddClassSchedule",
        name: "CourseAddClassSchedule",
        component: () =>
          import("../../views/Backstage/CourseEvaluationSchedule/ClassSchedule/AddClassSchedule.vue"),
        meta: {
          affiliation_Head: "Backstage", // 归属级 (头部的) **默认Backstage**
          affiliation_Left: "CourseEvaluationSchedule", // 归属级 (左侧的)
        },
      },
      {
        // 课表预览
        path: "/wenxiang_Backstage/CoursePreview",
        name: "CoursePreview",
        component: () =>
          import("../../views/Backstage/CourseEvaluationSchedule/ClassSchedule/Preview.vue"),
        meta: {
          affiliation_Head: "Backstage", // 归属级 (头部的) **默认Backstage**
          affiliation_Left: "CourseEvaluationSchedule", // 归属级 (左侧的)
        },
      },
      {
        // 名师
        path: "/wenxiang_Backstage/FamousTeachers",
        name: "FamousTeachers",
        component: () =>
          import("../../views/Backstage/FamousTeachers/index.vue"),
        meta: {
          affiliation_Head: "Backstage", // 归属级 (头部的) **默认Backstage**
          affiliation_Left: "FamousTeachers", // 归属级 (左侧的)
        },
      },
      {
        // 平台管理
        path: "/wenxiang_Backstage/Platform",
        name: "Platform",
        component: () =>
          import("../../views/Backstage/Basics/Platform/index.vue"),
        meta: {
          affiliation_Head: "Backstage", // 归属级 (头部的) **默认Backstage**
          affiliation_Left: "Platform", // 归属级 (左侧的)
        },
      },
      {
        // 用户管理
        path: "/wenxiang_Backstage/User",
        name: "User",
        component: () => import("../../views/Backstage/Basics/User/index.vue"),
        meta: {
          affiliation_Head: "Backstage", // 归属级 (头部的) **默认Backstage**
          affiliation_Left: "User", // 归属级 (左侧的)
        },
      },
      {
        // 设备管理
        path: "/wenxiang_Backstage/EquipmentManagement",
        name: "EquipmentManagement",
        component: () =>
          import("../../views/Backstage/Basics/EquipmentManagement/index.vue"),
        meta: {
          affiliation_Head: "Backstage", // 归属级 (头部的) **默认Backstage**
          affiliation_Left: "EquipmentManagement", // 归属级 (左侧的)
        },
      },
      {
        // 设备管理 -- 详情
        path: "/wenxiang_Backstage/EquipmentDetailView",
        name: "EquipmentDetailView",
        component: () =>
          import(
            "../../views/Backstage/Basics/EquipmentManagement/EquipmentDetailView/index.vue"
          ),
        meta: {
          affiliation_Head: "Backstage", // 归属级 (头部的) **默认Backstage**
          affiliation_Left: "EquipmentManagement", // 归属级 (左侧的)
        },
      },
      {
        // 行为分析管理
        path: "/wenxiang_Backstage/BehaviorAnalysis",
        name: "BehaviorAnalysis",
        component: () =>
          import("../../views/Backstage/Basics/BehaviorAnalysis/index.vue"),
        meta: {
          affiliation_Head: "Backstage", // 归属级 (头部的) **默认Backstage**
          affiliation_Left: "BehaviorAnalysis", // 归属级 (左侧的)
        },
      },
      {
        // 公告管理
        path: "/wenxiang_Backstage/Notice",
        name: "Notice",
        component: () =>
          import("../../views/Backstage/Basics/Notice/index.vue"),
        meta: {
          affiliation_Head: "Backstage", // 归属级 (头部的) **默认Backstage**
          affiliation_Left: "Notice", // 归属级 (左侧的)
        },
      },
      {
        // 公告管理--新增
        path: "/wenxiang_Backstage/NoticeAdd",
        name: "NoticeAdd",
        component: () =>
          import("../../views/Backstage/Basics/Notice/add/index.vue"),
        meta: {
          affiliation_Head: "Backstage", // 归属级 (头部的) **默认Backstage**
          affiliation_Left: "Notice", // 归属级 (左侧的)
        },
      },
    ],
  },
  {
    // 课程管理-课程章节-编辑章节
    path: "/wenxiang_Backstage/AddChapter",
    name: "AddChapter",
    component: () => import("../../views/Backstage/CourseInfoChapter/template/AddChapter.vue"),
    meta: {
      affiliation_Head: "Backstage", // 归属级 (头部的) **默认Backstage**
      affiliation_Left: "CourseNew", // 归属级 (左侧的)
    },
  },
  {
    // 课程管理-课程章节-编辑章节-添加测验
    path: "/wenxiang_Backstage/evaluationAddQuestions",
    name: "evaluationAddQuestions",
    component: () => import("../../views/Backstage/CourseInfoChapter/template/EvaluationTemplate/AddQuestions.vue"),
    meta: {
      affiliation_Head: "Backstage", // 归属级 (头部的) **默认Backstage**
      affiliation_Left: "CourseNew", // 归属级 (左侧的)
    },
  },
  {
    // 课程管理-测验管理-详情 批阅
    path: "/wenxiang_Backstage/Criticism",
    name: "Criticism",
    component: () => import("../../views/Backstage/CourseNew/topic"),
    meta: {
      affiliation_Head: "Backstage", // 归属级 (头部的) **默认Backstage**
      affiliation_Left: "CourseNew", // 归属级 (左侧的)
    },
  },
];
